export default __webpack_public_path__ + "static/media/ExcelLogo.f875fbb6.svg";